// extracted by mini-css-extract-plugin
module.exports = {"field-list":"src-components-molecules-FieldList-___style__field-list___2MXM4","term":"src-components-molecules-FieldList-___style__term___1fwnI"};